import axios from 'axios';
import keycloak from '../keycloak';

const api = axios.create();

api.interceptors.request.use(async (config) => {
    try {
        await keycloak.updateToken(30);
    } catch {
        keycloak.login();
        return Promise.reject(new Error('Session expired. Redirecting to login.'));
    }
    config.headers.Authorization = `Bearer ${keycloak.token}`;
    return config;
});

export default api;
